import React from "react"
import ContentLoader from "react-content-loader";

const NestedList = (props) => {
    return(
        <ContentLoader viewBox="0 0 500 90" height={90} width={500} {...props}>
        <rect x="0" y="0" rx="3" ry="3" width="350" height="10" />
        <rect x="20" y="20" rx="3" ry="3" width="270" height="10" />
        <rect x="0" y="40" rx="3" ry="3" width="350" height="10" />
        <rect x="20" y="60" rx="3" ry="3" width="250" height="10" />
        <rect x="20" y="80" rx="3" ry="3" width="80" height="10" />
    </ContentLoader>
    )
}
NestedList.metadata = {
    filename: 'Rectangle',
  }
export default NestedList